import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../../shared/shared.module';
import { reducers } from './reducers';
import { ChooseMethodComponent } from './components/choose-method/choose-method.component';
import { RegisterCodeComponent } from './components/register-code/register-code.component';
import { RegisterContractComponent } from './components/register-contract/register-contract.component';
import { RegisterEmailComponent } from './components/register-email/register-email.component';
import { RegisterCodePageComponent } from './containers/register-code-page.component';
import { RegisterContractPageComponent } from './containers/register-contract-page.component';
import { RegisterEmailPageComponent } from './containers/register-email-page.component';
import { RegisterEffects } from './effects/register.effects';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    StoreModule.forFeature('register', reducers),
    EffectsModule.forFeature([RegisterEffects]),
  ],
  exports: [
    ChooseMethodComponent,
    RegisterCodeComponent,
    RegisterContractComponent,
    RegisterEmailComponent,
    RegisterContractPageComponent,
    RegisterCodePageComponent,
    RegisterEmailPageComponent,
    /**/
  ],
  declarations: [
    ChooseMethodComponent,
    RegisterCodeComponent,
    RegisterContractComponent,
    RegisterEmailComponent,
    RegisterContractPageComponent,
    RegisterCodePageComponent,
    RegisterEmailPageComponent,
  ]
})
export class RegisterModule {
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/register.module.ts